export default "__VITE_ASSET__b6f12085__"